<div>
    <div *ngIf="loading">
        <app-spinner></app-spinner>
    </div>
    <div [hidden]="loading">
        <div class="filter filter--show-button">
            <fieldset class="filter__fieldset">
                <legend>Show repairs from the past:</legend>

                <div class="clearfix" data-toggle="repair">
                    <div>
                        <input type="radio" id="repairHistory-60" name="repairSelection" (click)="filter(60)">
                        <label for="repairHistory-60">
                            <span class="btn btn-secondary ">60 {{config.daysText}}</span>&nbsp;
                        </label>

                        <input type="radio" id="repairHistory-180" name="repairSelection" (click)="filter(180)">
                        <label for="repairHistory-180">
                            <span class="btn btn-secondary ">180 {{config.daysText}}</span>&nbsp;
                        </label>

                        <input type="radio" id="repairHistory-filter" name="repairSelection"
                            (click)="showCustomfilter()">
                        <label for="repairHistory-filter">
                            <span class="btn btn-secondary ">{{config.customText}}</span>
                        </label>
                    </div>

                </div>

                <div class="filter__columns" data-panel="fields-custom" *ngIf="config.filterCustom">
                    <div class="filter__column">
                        <div class="col-xs-4">
                            <label>{{config.fromText}}</label>
                            <input type="date" class="form-control" style="font-size: 12px; padding: 5px 0 5px 5px;"
                                (change)="onChangeFromDate($event)"
                                [value]="config.filterCustomFrom.toISOString().substring(0, 10)" required
                                min="2017-02-01" />
                        </div>
                        <div class="col-xs-4">
                            <label>{{config.toText}}</label>
                            <input type="date" class="form-control" style="font-size: 12px; padding: 5px 0 5px 5px;"
                                (change)="onChangeToDate($event)"
                                [value]="config.filterCustomTo.toISOString().substring(0, 10)" required
                                min="2017-02-01" />
                        </div>
                        <div class="col-xs-4" style="padding-right: 0; padding-top: 31px;">
                            <button class="btn btn-block btn-secondary" style="width: 98%;"
                                (click)="filter(0)">{{config.filterText}}</button>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <div us-spinner="{ position: 'relative'}" spinner-key="repairHistorySpinner" spinner-start-active="true">

            <h2 *ngIf="showNoRepairsFound">No repairs found</h2>
            <table class="table table-striped" [hidden]="showNoRepairsFound && !repairHistoryData"
                *ngFor="let repair of repairHistoryData  | orderBy: 'reportedDate':false">
                <thead>
                    <tr>
                        <th class="col-xs-6">Repair Description</th>
                        <th class="col-xs-6">Appointments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr></tr>
                    <tr *ngFor="let repairJob of repair.repairJobs">

                        <td>
                            <strong>Job Number: {{repairJob.jobNumber}}</strong>
                            <ul>
                                <li *ngFor="let sor of repairJob.sors">{{sor.description}}</li>
                            </ul>
                            <span class="table__label">{{repairJob.status}}</span>
                            <span class="table__label">Reported: {{repair.reportedDate | date:'dd MMM yyyy'}}</span>
                        </td>
                        <td>
                            <p><strong condition="$first"
                                    *ngFor="let appointment of repairJob.appointments | limitTo:1 | futureDates | orderBy: 'startTime'">Next
                                    appointment:</strong>
                            <p>
                            <p condition="$first"
                                *ngFor="let appointment of repairJob.appointments |  limitTo:1 | futureDates | orderBy: 'startTime'">
                                {{appointment.startTime | date:'dd MMM yyyy hh:mma'}}</p>

                            <p
                                *ngFor="let appointment of repairJob.appointments | previousDates | limitTo:1 | orderBy: 'startTime'">
                                <strong>Previous appointment(s)</strong>
                            </p>
                            <p
                                *ngFor="let appointment of repairJob.appointments | previousDates | orderBy: 'startTime'">
                                {{appointment.startTime | date:'dd MMM yyyy hh:mma'}} - {{appointment.status === "Open"
                                ? "Active" : appointment.status}}</p>

                            <span condition="$first"
                                *ngFor="let appointment of repairJob.appointments |  limitTo:1 | futureDates | orderBy: 'startTime'">
                                <!--<a class="btn btn-primary btn-small" ng-show="appointment.status==='Scheduled'" href="/repairs/reschedule?repairId={{repair.id}}&repairJobId={{repairJob.id}}&previousSlotKey={{appointment.slotKey}}">Reschedule</a>-->
                                <a class="btn btn-primary btn-small" *ngIf="appointment.status==='Scheduled'"
                                    [href]="'/repairs/cancel-a-repair/?repairJobId='+ repairJob.id + '&repairStartTime=' + appointment.startTime  + '&repairDescription=' + repairJob.jobNumber">Cancel</a>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>